import React, {useState, useEffect} from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading} from 'components/form';
import {required, validationWrapper, number} from 'lib/formValidations';
import {transformTranslateFromValues, transformTranslateServerValues} from 'lib/helpers';
import Modal from 'components/Modal'
import {TextArea, Select} from 'components/form';
import {GalleryField} from 'components/form';
import {useCore} from 'store/core';
import { AddPrices } from './AddPrices';
// components

export default function Edit(props) {

    const core = useCore();
    const {show, item} = props;
    const [prices, setPrices] = useState([]);
    const [showAddPrice, setShowAddPrice] = useState(false);
    useEffect(() => {
    if (item && item.prices) {
        setPrices(
          item.prices.map((i) => ({
            uuid: i.id,
            currency: i.currency,
            amount: i.amount,
            status: i.status,
          }))
        );
      }
    },[item]);
    const _renderPrices = () => {
        return prices.map((item) => (
          <div className="grid grid-cols-4 gap-3">
            <h5>{item.currency === "USD" ? "دلار" : "تومان"}</h5>
            <h5 className="text-center">{item.amount}</h5>
            <h5 className="text-center">
              <button
                type="button"
                className={`btn btn-sm ${
                  item.status ? "btn-success" : "btn-danger"
                }`}
                onClick={() => {
                  setPrices([
                    ...prices.filter((i) => i.uuid !== item.uuid),
                    { ...item, status: !item.status },
                  ]);
                }}
              >
                {item.status ? "فعال" : "غیرفعال"}
              </button>
            </h5>
            <div className="flex justify-center items-center">
              <button
                type="button"
                onClick={() => {
                  setPrices(prices.filter((i) => i.uuid != item.uuid));
                }}
                className="btn btn-sm btn-danger"
              >
                حذف
              </button>
            </div>
          </div>
        ));
      };


    return (
        <>
        <AddPrices
        close={() => setShowAddPrice(false)}
        show={showAddPrice}
        submit={(values) => {
          setPrices([...prices, values]);
        }}
      />
            <Modal show={props.show} handleClose={props.close} title={props.title}>
                <Formik
                    initialValues={{...transformTranslateServerValues(item)}}
                    onSubmit={async (values, {setSubmitting}) => {
                        values.prices=prices
                        await props.submit(transformTranslateFromValues(values), item.id);
                        props.close();
                        setSubmitting(false);
                    }}
                    enableReinitialize
                >

                    {({isSubmitting, dirty}) => (
                        <Form>
                            <div className="modal-body gap-y-3">
                                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                                    
                                   <Field
                                        placeholder="نام"
                                        label="نام :"
                                        name="name"
                                        component={TextField}
                                        validate={(value) => validationWrapper(value, required)}
                                    />
                                    <Field
                                        placeholder="name"
                                        label="نام انگلیسی :"
                                        name="_en*name*text"
                                        component={TextField}
                                    />
                                    <Field
                                        label="توضیحات :"
                                        name="desc"
                                        component={TextArea}
                                    />
                                    <Field
                                        label="description"
                                        name="_en*desc*text"
                                        component={TextArea}
                                    />
                                     <Field
                                        label="نوع:"
                                        name="type"
                                        component={Select}
                                        options={[{'label':'تهران',value:'TEHRAN'},
                                                {'label':'شهرستان ها',value:'IRAN'},
                                                {'label':'جهانی',value:'GLOBAL'},
                                        ]}
                                    />
                                </div>
                            </div>
                            <div className="intro-y col-span-12 border rounded p-2 border-theme-21">
                <div className="flex justify-between items-center">
                  <h2>قیمت ها :</h2>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => setShowAddPrice(true)}
                  >
                    افزودن قیمت
                  </button>
                </div>
                <hr className="my-2" />
                <div className="grid grid-cols-1 gap-4 mt-3">
                  <div className="grid grid-cols-4 gap-3">
                    <h5>واحد پولی</h5>
                    <h5 className="text-center">مقدار</h5>
                    <h5 className="text-center">وضعیت</h5>
                    <div className="flex justify-center items-center">
                      عملیات
                    </div>
                  </div>
                  {_renderPrices()}
                </div>
              </div>
                            <div className="modal-footer text-right">
                                <button className="btn btn-primary w-20" type="submit"
                                        disabled={!!(isSubmitting || !dirty)}> {isSubmitting ?
                                    <Loading/> : 'ذخیره'}</button>
                                <button type="button"
                                        disabled={isSubmitting}
                                        onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">انصراف
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
}
